import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';

import { UsuarioService } from '../services/usuario.service';
import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import { VeiculoService } from '../services/veiculo.service';
import { CheckAmbulanciaService } from '../services/check-ambulancia.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-checklist-edit',
  templateUrl: './checklist-edit.component.html',
  styleUrls: ['./checklist-edit.component.css'],
	animations: [loadingFade]
})

export class ChecklistEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public inicioPeriodo;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];

  public check_ambulancia_id = null;
  public profissional = null;


  //filtros
  public cliente_id___cliente = null;
  public unidade_id___unidade = null;
  public veiculo_id___veiculo = null;
  public check_ambulancia_turno___periodo = null;
  public check_ambulancia_data___data_i = null;
  public check_ambulancia_data___data_f=  null;
  public especialidade_veiculo_id___veiculo = null;
  public profissional_id___profissional = null;

  // datepickers
	private data_checklist_dp;
  
  constructor(private authSvc: AuthService,
              private usuarioSvc: UsuarioService,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private router: Router,
              private clienteSvc: ClienteService,
              private unidadeSvc: UnidadeService,
              private profissionalSvc: ProfissionalService ,
              private veiculoSvc: VeiculoService,
              private checkAmbulanciaSvc: CheckAmbulanciaService
              ) { }

  ngOnInit() {
    this.pegaAgencias();
    ///this.pegaProfissionais();
    this.criaForm();
    this.verificaCliente();
    this.loading = true;

		this.route.params.subscribe( params => {

      if (params.id) {

        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_ambulancia_turno___periodo": { 
                this.check_ambulancia_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_ambulancia_data___data_i": { 
                this.check_ambulancia_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_ambulancia_data___data_f": { 
                this.check_ambulancia_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "especialidade_veiculo_id___veiculo": { 
                this.especialidade_veiculo_id___veiculo = loSplitValor[1];
                 break; 
              }    
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }

				this.check_ambulancia_id = params.id;
				this.checkAmbulanciaSvc.getCheckAmbulancia(params.id).then((data: any) => {
          this.pegaUnidadesByAgencia(data.cliente_id);
          this.pegaVeiculosByUnidade(data.unidade_id);
          this.onChangeVeiculoUnidade(data);
					this.preencheForm({
            check_ambulancia_id:  data.check_ambulancia_id,
            usuario_id:  data.usuario_id,
            check_ambulancia_data:  moment(data.check_ambulancia_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_ambulancia_turno:  data.check_ambulancia_turno,
            cliente_id:  data.cliente_id,
            unidade_id:  data.unidade_id,
            profissional_id:  data.profissional_id,
            veiculo_id:  data.veiculo_id,
            check_ambulancia_justificativa:  data.check_ambulancia_justificativa,
            check_ambulancia_quilometragem:  this.mascaraKm(data.check_ambulancia_quilometragem),
            check_ambulancia_combustivel:  data.check_ambulancia_combustivel,
            check_ambulancia_oleo_motor: data.check_ambulancia_oleo_motor,
            check_ambulancia_oleo_motor_obs: data.check_ambulancia_oleo_motor_obs,
            check_ambulancia_agua_radiador: data.check_ambulancia_agua_radiador,
            check_ambulancia_agua_radiador_obs: data.check_ambulancia_agua_radiador_obs,
            check_ambulancia_fluido_freio: data.check_ambulancia_fluido_freio,
            check_ambulancia_fluido_freio_obs: data.check_ambulancia_fluido_freio_obs,
            check_ambulancia_injetor_agua: data.check_ambulancia_injetor_agua,
            check_ambulancia_injetor_agua_obs: data.check_ambulancia_injetor_agua_obs,
            check_ambulancia_freio_de_mao: data.check_ambulancia_freio_de_mao,
            check_ambulancia_freio_de_mao_obs: data.check_ambulancia_freio_de_mao_obs,
            check_ambulancia_partida: data.check_ambulancia_partida,
            check_ambulancia_partida_obs: data.check_ambulancia_partida_obs,
            check_ambulancia_luz_re: data.check_ambulancia_luz_re,
            check_ambulancia_luz_re_obs: data.check_ambulancia_luz_re_obs,
            check_ambulancia_luz_freio: data.check_ambulancia_luz_freio,
            check_ambulancia_luz_freio_obs: data.check_ambulancia_luz_freio_obs,
            check_ambulancia_sirene: data.check_ambulancia_sirene,
            check_ambulancia_sirene_obs: data.check_ambulancia_sirene_obs,
            check_ambulancia_buzina: data.check_ambulancia_buzina,
            check_ambulancia_buzina_obs: data.check_ambulancia_buzina_obs,
            check_ambulancia_ac: data.check_ambulancia_ac,
            check_ambulancia_ac_obs: data.check_ambulancia_ac_obs,
            check_ambulancia_ilu_salao: data.check_ambulancia_ilu_salao,
            check_ambulancia_ilu_salao_obs: data.check_ambulancia_ilu_salao_obs,
            check_ambulancia_tomadas: data.check_ambulancia_tomadas,
            check_ambulancia_tomadas_obs: data.check_ambulancia_tomadas_obs,
            check_ambulancia_cinto: data.check_ambulancia_cinto,
            check_ambulancia_cinto_obs: data.check_ambulancia_cinto_obs,
            check_ambulancia_cones: data.check_ambulancia_cones,
            check_ambulancia_cones_obs: data.check_ambulancia_cones_obs,
            check_ambulancia_extintor: data.check_ambulancia_extintor,
            check_ambulancia_extintor_obs: data.check_ambulancia_extintor_obs,
            check_ambulancia_macaco: data.check_ambulancia_macaco,
            check_ambulancia_macaco_obs: data.check_ambulancia_macaco_obs,
            check_ambulancia_chave_roda: data.check_ambulancia_chave_roda,
            check_ambulancia_chave_roda_obs: data.check_ambulancia_chave_roda_obs,
            check_ambulancia_triangulo: data.check_ambulancia_triangulo,
            check_ambulancia_triangulo_obs: data.check_ambulancia_triangulo_obs,
            check_ambulancia_radio: data.check_ambulancia_radio,
            check_ambulancia_radio_obs: data.check_ambulancia_radio_obs,
            check_ambulancia_gps: data.check_ambulancia_gps,
            check_ambulancia_gps_obs: data.check_ambulancia_gps_obs,
            check_ambulancia_celular: data.check_ambulancia_celular,
            check_ambulancia_celular_obs: data.check_ambulancia_celular_obs,
            check_ambulancia_carregador: data.check_ambulancia_carregador,
            check_ambulancia_carregador_obs: data.check_ambulancia_carregador_obs,
            check_ambulancia_antena: data.check_ambulancia_antena,
            check_ambulancia_antena_obs: data.check_ambulancia_antena_obs,
            check_ambulancia_pneus: data.check_ambulancia_pneus,
            check_ambulancia_pneus_obs: data.check_ambulancia_pneus_obs,
            check_ambulancia_estepe: data.check_ambulancia_estepe,
            check_ambulancia_estepe_obs: data.check_ambulancia_estepe_obs,
            check_ambulancia_portas: data.check_ambulancia_portas,
            check_ambulancia_portas_obs: data.check_ambulancia_portas_obs,
            check_ambulancia_vidros: data.check_ambulancia_vidros,
            check_ambulancia_vidros_obs: data.check_ambulancia_vidros_obs,
            check_ambulancia_lavada: data.check_ambulancia_lavada,
            check_ambulancia_lavada_obs: data.check_ambulancia_lavada_obs,
            check_ambulancia_inicio: data.check_ambulancia_inicio,
            check_ambulancia_fim: data.check_ambulancia_fim,
            check_ambulancia_giroflex: data.check_ambulancia_giroflex,
            check_ambulancia_giroflex_obs: data.check_ambulancia_giroflex_obs,
            check_ambulancia_estrobo: data.check_ambulancia_estrobo,
            check_ambulancia_estrobo_obs: data.check_ambulancia_estrobo_obs,
            check_ambulancia_retrovisores: data.check_ambulancia_retrovisores,
            check_ambulancia_farois: data.check_ambulancia_farois,
            check_ambulancia_piscas: data.check_ambulancia_piscas,
            check_ambulancia_lanterna_tras: data.check_ambulancia_lanterna_tras,
            check_ambulancia_retrovisores_obs: data.check_ambulancia_retrovisores_obs,
            check_ambulancia_farois_obs: data.check_ambulancia_farois_obs,
            check_ambulancia_piscas_obs: data.check_ambulancia_piscas_obs,
            check_ambulancia_lanterna_tras_obs: data.check_ambulancia_lanterna_tras_obs,
            check_ambulancia_palheta:data.check_ambulancia_palheta,
            check_ambulancia_palheta_obs:data.check_ambulancia_palheta_obs,
            check_ambulancia_luz_placa:data.check_ambulancia_luz_placa,
            check_ambulancia_luz_placa_obs:data.check_ambulancia_luz_placa_obs,
            check_ambulancia_cilindro_o2:data.check_ambulancia_cilindro_o2,
            check_ambulancia_cilindro_o2_obs:data.check_ambulancia_cilindro_o2_obs,
            check_ambulancia_chave_o2:data.check_ambulancia_chave_o2,
            check_ambulancia_chave_o2_obs:data.check_ambulancia_chave_o2_obs,
            check_ambulancia_maca_rigida:data.check_ambulancia_maca_rigida,
            check_ambulancia_maca_rigida_obs:data.check_ambulancia_maca_rigida_obs,
            check_ambulancia_maca_retratil:data.check_ambulancia_maca_retratil,
            check_ambulancia_maca_retratil_obs:data.check_ambulancia_maca_retratil_obs,
            check_ambulancia_cartao_abast:data.check_ambulancia_cartao_abast,
            check_ambulancia_cartao_abast_obs:data.check_ambulancia_cartao_abast_obs,
            check_ambulancia_obs:data.check_ambulancia_obs,
            check_ambulancia_intercorrencia:data.check_ambulancia_intercorrencia,
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
    });
  }

  criaForm(){
    
    this.formChecklist = this.fb.group({
			check_ambulancia_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
      check_ambulancia_data: [moment().format('DD/MM/YYYY'), Validators.required],
      check_ambulancia_turno: [this.pegaPeriodo(), Validators.required],
      cliente_id: [null, Validators.required],
      unidade_id: [null, Validators.required],
      profissional_id: [this.profissional, Validators.required],
      veiculo_id: [null, Validators.required],
      check_ambulancia_justificativa: [null],
      check_ambulancia_quilometragem: [null, Validators.required],
      check_ambulancia_combustivel: [null, Validators.required],
      check_ambulancia_oleo_motor:[null, Validators.required],
      check_ambulancia_oleo_motor_obs:null,
      check_ambulancia_agua_radiador:[null, Validators.required],
      check_ambulancia_agua_radiador_obs:null,
      check_ambulancia_fluido_freio:[null, Validators.required],
      check_ambulancia_fluido_freio_obs:null,
      check_ambulancia_injetor_agua:[null, Validators.required],
      check_ambulancia_injetor_agua_obs:null,
      check_ambulancia_freio_de_mao:[null, Validators.required],
      check_ambulancia_freio_de_mao_obs:null,
      check_ambulancia_partida:[null, Validators.required],
      check_ambulancia_partida_obs:null,
      check_ambulancia_luz_re:[null, Validators.required],
      check_ambulancia_luz_re_obs:null,
      check_ambulancia_luz_freio:[null, Validators.required],
      check_ambulancia_luz_freio_obs:null,
      check_ambulancia_sirene:[null, Validators.required],
      check_ambulancia_sirene_obs:null,
      check_ambulancia_buzina:[null, Validators.required],
      check_ambulancia_buzina_obs:null,
      check_ambulancia_ac:[null, Validators.required],
      check_ambulancia_ac_obs:null,
      check_ambulancia_ilu_salao:[null, Validators.required],
      check_ambulancia_ilu_salao_obs:null,
      check_ambulancia_tomadas:[null, Validators.required],
      check_ambulancia_tomadas_obs:null,
      check_ambulancia_cinto:[null, Validators.required],
      check_ambulancia_cinto_obs:null,
      check_ambulancia_cones:[null, Validators.required],
      check_ambulancia_cones_obs:null,
      check_ambulancia_extintor:[null, Validators.required],
      check_ambulancia_extintor_obs:null,
      check_ambulancia_macaco:[null, Validators.required],
      check_ambulancia_macaco_obs:null,
      check_ambulancia_chave_roda:[null, Validators.required],
      check_ambulancia_chave_roda_obs:null,
      check_ambulancia_triangulo:[null, Validators.required],
      check_ambulancia_triangulo_obs:null,
      check_ambulancia_radio:[null, Validators.required],
      check_ambulancia_radio_obs:null,
      check_ambulancia_gps:[null, Validators.required],
      check_ambulancia_gps_obs:null,
      check_ambulancia_celular:[null, Validators.required],
      check_ambulancia_celular_obs:null,
      check_ambulancia_carregador:[null, Validators.required],
      check_ambulancia_carregador_obs:null,
      check_ambulancia_antena:[null, Validators.required],
      check_ambulancia_antena_obs:null,
      check_ambulancia_pneus:[null, Validators.required],
      check_ambulancia_pneus_obs:null,
      check_ambulancia_estepe:[null, Validators.required],
      check_ambulancia_estepe_obs:null,
      check_ambulancia_portas:[null, Validators.required],
      check_ambulancia_portas_obs:null,
      check_ambulancia_vidros:[null, Validators.required],
      check_ambulancia_vidros_obs:null,
      check_ambulancia_lavada:[null, Validators.required],
      check_ambulancia_lavada_obs:null,
      check_ambulancia_giroflex: [null, Validators.required],
      check_ambulancia_giroflex_obs: null,
      check_ambulancia_estrobo: [null, Validators.required],
      check_ambulancia_estrobo_obs: null,
      check_ambulancia_inicio: moment().format('YYYY-MM-DD HH:mm:ss'),
      check_ambulancia_fim: null,
      check_ambulancia_retrovisores: [null, Validators.required],
      check_ambulancia_retrovisores_obs: null,
      check_ambulancia_farois: [null, Validators.required],
      check_ambulancia_farois_obs: null,
      check_ambulancia_piscas: [null, Validators.required],
      check_ambulancia_piscas_obs: null,
      check_ambulancia_lanterna_tras: [null, Validators.required],
      check_ambulancia_lanterna_tras_obs: null,
      check_ambulancia_palheta: [null, Validators.required],
      check_ambulancia_palheta_obs: null,
      check_ambulancia_luz_placa: [null, Validators.required],
      check_ambulancia_luz_placa_obs: null,
      check_ambulancia_cilindro_o2: [null, Validators.required],
      check_ambulancia_cilindro_o2_obs: [null, Validators.required],
      check_ambulancia_chave_o2: [null, Validators.required],
      check_ambulancia_chave_o2_obs: null,
      check_ambulancia_maca_rigida: [null, Validators.required],
      check_ambulancia_maca_rigida_obs: null,
      check_ambulancia_maca_retratil: [null, Validators.required],
      check_ambulancia_maca_retratil_obs: null,
      check_ambulancia_cartao_abast: [null, Validators.required],
      check_ambulancia_cartao_abast_obs: null,
      check_ambulancia_obs: null,
      check_ambulancia_intercorrencia: null,
    });
    
    moment.locale('pt-Br');
    this.data_checklist_dp = Datepicker('#check_ambulancia_data', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formChecklist.controls['check_ambulancia_data'].setValue(formatted);
			}
    });

    let hora = parseInt(moment().format('HH'));
    let min = parseInt(moment().format('mm'));
    if([7, 19].includes(hora) && (min >= 0 && min < 31)){
      this.inicioPeriodo = true;
    }else{      
      this.inicioPeriodo = false;
    }

    if(this.authSvc.getPerfil() != 2){
      this.usuarioSvc.getUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
        this.profissional = data.profissional_id;
        this.formChecklist.get('profissional_id').setValue(data.profissional_id);
        this.formChecklist.get('profissional_id').updateValueAndValidity();
        this.formChecklist.get('profissional_id').disable();
      });
    }

  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }
  

  pegaPeriodo(){
    let hora = parseInt(moment().format('HH'));
    if(hora > 7  &&  hora < 19){
      return 'D';
    }
    else{
      return 'N';
    }
  }

  pegaAgencias(){
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.agencias = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidadesByAgencia(agencia_id){
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }
  
  pegaVeiculosByUnidade(unidade_id){
    this.veiculoSvc.getByTipoVeiculo(unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  onChangeAgencia(e){
    this.formChecklist.controls.unidade_id.setValue(null);
    this.formChecklist.controls.veiculo_id.setValue(null);
    this.verificaCliente();
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeUnidade(e){
    console.log(e);
    this.veiculoSvc.getByTipoVeiculo(e.unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  onChangeVeiculoUnidade(e){

		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"ambulancia").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}
	
			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
	}
	
	pegaProfissionaisClienteUnidade(e){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	

  pegaProfissionais(){
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
			this.profissionais = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  invalid(nome) {
    let input = this.formChecklist.get(nome);
		return input.touched && input.invalid;
  }
  
  verificaCliente() {
		if (this.formChecklist.get('cliente_id').value)
			this.formChecklist.get('unidade_id').enable();
		else
			this.formChecklist.get('unidade_id').disable();
	}
  
  enviaChecklist() {
    console.log(this.formChecklist.value);
    
    if (this.formChecklist.valid) {
      this.submitting = true;
      this.formChecklist.get('profissional_id').enable();
      let toSend = this.formChecklist.value;
      
      if (this.check_ambulancia_id === null) { // criar
        toSend.check_ambulancia_registro = moment().format('YYYY-MM-DD HH:mm:ss');
        toSend.check_ambulancia_fim = moment().format('YYYY-MM-DD HH:mm:ss');

				this.checkAmbulanciaSvc.criaCheckAmbulancia(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Checklist cadastrado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/checklist']);
            }
          });
				}).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
			else { // editar
				this.checkAmbulanciaSvc.editaCheckAmbulancia(toSend).then((data) => {
          console.log('resp', data);
				  Swal.fire({
            type: 'success',
            title: 'Checklist alterado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/checklist']);
            }
          });
				}).catch(err => {
					console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
    }
    else{
      Swal.fire({
        type: 'error',
        title: 'Checklist incompleto!',
        text: 'Verifique os itens em vermelho!'
      });
      for( let field in this.formChecklist.controls){
        let campo = this.formChecklist.get(field);
        campo.markAsTouched();
      }
    }
  }

  onChangeRadio(nome) {

    let inputRadio = this.formChecklist.get(nome);
    let inputObs = this.formChecklist.get(nome + '_obs');

    if (inputRadio.value === 'N') {
      inputObs.setValidators(Validators.required);
      inputObs.updateValueAndValidity();
      inputObs.markAsTouched();
      inputObs.invalid;
    } else {
      inputObs.clearValidators();
      inputObs.updateValueAndValidity();
    }
  }

  onChangeVeiculo(e){
    if(e.veiculo_checklist == 'S'){
      Swal.fire({
        type:'question',
        title:'Veículo isento de Checklist',
        text:'Finalizar checklist?',
        showCancelButton: true,
        cancelButtonText:'Não',
        confirmButtonText:'Sim',
        
      }).then((result) => {
        if (result.value) {
          this.onConfirm();

        }
      });
    }
  }

  onConfirm() {
    this.submitting = true;
    this.formChecklist.get('profissional_id').enable();
    let toSend = this.formChecklist.value;

    if(!(toSend.check_ambulancia_data == null || toSend.check_ambulancia_data == null || toSend.cliente_id == null || toSend.unidade_id == null)){
      if (this.check_ambulancia_id === null) { // criar
        toSend.check_ambulancia_registro = moment().format('YYYY-MM-DD HH:mm:ss');
        toSend.check_ambulancia_fim = moment().format('YYYY-MM-DD HH:mm:ss');

        this.checkAmbulanciaSvc.criaCheckAmbulancia(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Checklist cadastrado com sucesso!',
            onClose: ()=>{
              this.router.navigate(['home/checklist']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
        });
      }
      else { // editar
        this.checkAmbulanciaSvc.editaCheckAmbulancia(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Checklist alterado com sucesso!',
            onClose: ()=>{
              this.router.navigate(['home/checklist']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
        });
      }
    }
    else{
      Swal.fire({
        type: 'error',
        title: 'Checklist incompleto!',
        text: 'Ops! Algo de errado aconteceu!'
      });
    }
  }

  onClickVoltar(){

    let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
    params += "&unidade_id___unidade=" + this.unidade_id___unidade;
    params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
    params += "&check_ambulancia_turno___periodo=" + this.check_ambulancia_turno___periodo;
    params += "&check_ambulancia_data___data_i=" + this.check_ambulancia_data___data_i;
    params += "&check_ambulancia_data___data_f=" + this.check_ambulancia_data___data_f;
    params += "&especialidade_veiculo_id___veiculo=" + this.especialidade_veiculo_id___veiculo;
    params += "&profissional_id___profissional=" + this.profissional_id___profissional;

    console.log("[onClickVoltar]", params);

    this.router.navigate(['/home/checklistfiltro/' + params]);

    this.router.navigate(['/home/checklist']);

  }

  mascaraKm(valor){

		if(valor != "" && valor != null){

			if(valor.length <= 3){
				return valor;
			}else{

				if(valor.indexOf(".") != -1){

					var sValor = valor.split(".");
					if(sValor[1] == "000"){
						return sValor[0];
					}else{
						return sValor[0] + sValor[1];
					}

				}

			}


		}else{
      return "";
    }

	  }

}
